import { navColumnCss, previewColumnCss, stickyNavCss, stickyPreviewColumnCss } from './sticky_chrome';
import { PreviewPanel } from '../components/preview_panel';
import { TabNav, tabId, tabPanelId } from '../components/tab_nav';
import { ActiveTabPanels } from '../tabs/active_tab_panels';

// Figma Main content: spacing1_5x inset on top/left/right. Content column ~500;
// preview takes the rest so the month calendar can show all 7 days.
//
// The preview must never grow the row past the scrollport: a tall sticky
// calendar used to inflate #shell-content-scroll past the form, and focus/Tab
// scrollIntoView then showed empty shell background ("half screen"). The nav
// and preview columns are capped to the scrollport for that reason.
const bodyCss = "b9lu2wv";
const contentCss = "cut8a4s";
export const LargeLayout = ({
  activeTab,
  tabs,
  onSelectTab,
  etLocks,
  invalidTabKeys,
  lockingDisables,
  panelKeys,
  panelPropsByKey
}) => <div className={bodyCss}>
    <div className={navColumnCss}>
      <TabNav tabs={tabs} activeTabKey={activeTab.key} onSelectTab={onSelectTab} invalidTabKeys={invalidTabKeys} className={stickyNavCss} />
    </div>
    <main className={contentCss} role="tabpanel" id={tabPanelId(activeTab.key)} aria-labelledby={tabId(activeTab.key)}>
      <ActiveTabPanels tabKey={activeTab.key} etLocks={etLocks} lockingDisables={lockingDisables} panelKeys={panelKeys} panelPropsByKey={panelPropsByKey} />
    </main>
    <div className={previewColumnCss}>
      <PreviewPanel className={stickyPreviewColumnCss} />
    </div>
  </div>;

require("./large_layout.wyw-in-js.css!=!../../../../../node_modules/@wyw-in-js/webpack-loader/lib/outputCssLoader.js?cacheProvider=!./large_layout.js");